(function () {
  if (window.KobuEducationProgressInitialized) return;
  window.KobuEducationProgressInitialized = true;

  var storageKey = 'kobu-retailer-education-completed-videos';

  function getCompletedVideos() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveCompletedVideos(videoIds) {
    localStorage.setItem(storageKey, JSON.stringify(videoIds));
  }

  function isComplete(videoIds) {
    var completedVideos = getCompletedVideos();
    return videoIds.length > 0 && videoIds.every(function (videoId) {
      return completedVideos.indexOf(String(videoId)) !== -1;
    });
  }

  function showSubmission() {
    var submission = document.querySelector('[data-education-submission]');
    if (!submission) return;
    submission.hidden = false;
    submission.classList.remove('kobu-education-final--locked');
  }

  var videoCheckbox = document.querySelector('[data-education-video-checkbox]');
  if (videoCheckbox) {
    var currentVideoId = String(videoCheckbox.dataset.videoId);
    var completedVideos = getCompletedVideos();
    videoCheckbox.checked = completedVideos.indexOf(currentVideoId) !== -1;

    videoCheckbox.addEventListener('change', function () {
      var updatedVideos = getCompletedVideos().filter(function (videoId) {
        return String(videoId) !== currentVideoId;
      });
      if (videoCheckbox.checked) updatedVideos.push(currentVideoId);
      saveCompletedVideos(updatedVideos);
    });
  }

  var completionCta = document.querySelector('[data-education-completion-cta]');
  var submissionSuccess = document.querySelector('[data-education-submission-success]');

  if (submissionSuccess) {
    showSubmission();
    if (completionCta) completionCta.hidden = true;
    return;
  }

  if (!completionCta) return;

  var videoIds;
  try {
    videoIds = JSON.parse(completionCta.dataset.videoIds || '[]').map(String);
  } catch (error) {
    videoIds = [];
  }

  var completionButton = completionCta.querySelector('[data-education-complete-button]');
  var updateCompletionButton = function () {
    var complete = isComplete(videoIds);
    completionButton.disabled = !complete;
    completionButton.setAttribute('aria-disabled', String(!complete));
  };

  updateCompletionButton();

  completionButton.addEventListener('click', function () {
    if (completionButton.disabled) return;
    showSubmission();
    window.location.hash = 'KobuEducationFinalSubmission';
  });

  if (isComplete(videoIds) && window.location.hash === '#KobuEducationFinalSubmission') {
    showSubmission();
  }
})();
